import { useEffect, useState } from "react";
import axios from "axios";
import { useSearchParams } from "react-router-dom";
import { CheckCircle, XCircle } from "@phosphor-icons/react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const Shell = ({ children, testid }) => (
  <div className="flex min-h-screen flex-col items-center justify-center bg-ink px-6 text-center text-paper" data-testid={testid}>
    <div className="grain-overlay" />
    {children}
    <a href="/libreria" className="mt-10 border border-white/15 px-7 py-3 text-[10px] font-light uppercase tracking-[0.25em] text-paper/70 transition-colors hover:border-fire hover:text-fire" data-testid="compra-volver">
      Volver a la librería
    </a>
  </div>
);

export const CompraExitosa = () => {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const [estado, setEstado] = useState("verificando");

  useEffect(() => {
    document.title = "Pedido confirmado — Librería Viento de Gracia";
    if (!sessionId) {
      setEstado("error");
      return;
    }
    let intentos = 0;
    const timer = setInterval(async () => {
      intentos += 1;
      try {
        const { data } = await axios.get(`${API}/libreria/pago/${sessionId}`);
        if (data.payment_status === "paid") {
          setEstado("pagado");
          clearInterval(timer);
        }
      } catch {
        /* reintenta */
      }
      if (intentos >= 10) {
        setEstado((e) => (e === "verificando" ? "pendiente" : e));
        clearInterval(timer);
      }
    }, 2000);
    return () => clearInterval(timer);
  }, [sessionId]);

  if (estado === "verificando") {
    return (
      <Shell testid="exito-verificando">
        <img src="/logo-mark-oficial.png" alt="Verificando" className="h-14 w-14 animate-float-slow object-contain" />
        <p className="mt-8 font-serif text-3xl italic text-smoke">Confirmando tu pago...</p>
      </Shell>
    );
  }

  if (estado === "pagado") {
    return (
      <Shell testid="exito-pagado">
        <CheckCircle size={52} weight="light" className="text-fire" />
        <h1 className="mt-8 font-serif text-4xl lg:text-5xl">¡Gracias por tu compra!</h1>
        <p className="mt-4 max-w-md text-sm font-light leading-relaxed text-smoke">
          Tu pedido está confirmado y pagado. Nos pondremos en contacto contigo para la entrega.
          Tu compra apoya directamente la obra de Viento de Gracia — que Dios te bendiga.
        </p>
      </Shell>
    );
  }

  return (
    <Shell testid="exito-pendiente">
      <CheckCircle size={52} weight="light" className="text-fire" />
      <h1 className="mt-8 font-serif text-4xl lg:text-5xl">Estamos confirmando tu pago</h1>
      <p className="mt-4 max-w-md text-sm font-light leading-relaxed text-smoke">
        El pago puede tardar unos minutos en reflejarse. Si ya se hizo el cargo a tu tarjeta, tu pedido está seguro —
        escríbenos por WhatsApp si tienes dudas.
      </p>
    </Shell>
  );
};

export const CompraCancelada = () => {
  useEffect(() => {
    document.title = "Pago cancelado — Librería Viento de Gracia";
  }, []);
  return (
    <Shell testid="compra-cancelada">
      <XCircle size={52} weight="light" className="text-smoke" />
      <h1 className="mt-8 font-serif text-4xl lg:text-5xl">Pago cancelado</h1>
      <p className="mt-4 max-w-md text-sm font-light leading-relaxed text-smoke">
        No se hizo ningún cargo. El libro sigue disponible para ti cuando quieras retomar la compra.
      </p>
    </Shell>
  );
};
